import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "@/store";
import en from "@/lang/en";
import fr from "@/lang/fr";
import es from "@/lang/es";
import ga from "@/lang/ga";
import pl from "@/lang/pl";
import axios from "axios";

Vue.use(VueI18n);

const numberFormats = {
  "en-US": {
    currency: {
      style: "currency",
      currency: "USD",
      currencyDisplay: "symbol",
    },
  },
  en: {
    currency: {
      style: "currency",
      currency: "EUR",
      currencyDisplay: "symbol",
    },
  },
};
const dateTimeFormats = {
  "en-US": {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    },
  },
};

export const i18n = new VueI18n({
  locale: store.state.language ? store.state.language : "EN",
  fallbackLocale: store.state.language,
  messages: { EN: en, GA: ga, FR: fr, ES: es, PL: pl },
  numberFormats,
  dateTimeFormats,
});

const loadedLanguages = ["en", "ga", "fr", "es", "pl"];

store.watch(
  (state) => state.language,
  (newVal) => {
    i18n.locale = newVal;
    i18n.fallbackLocale = newVal;
  }
);

function setI18nLanguage(lang) {
  i18n.locale = lang;
  axios.defaults.headers.common["Accept-Language"] = lang;
  document.querySelector("html").setAttribute("lang", lang);
  return lang;
}

export function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language hasn't been loaded yet
  return import(
    /* webpackChunkName: "lang-[request]" */ `@/lang/${lang}.js`
  ).then((messages) => {
    i18n.setLocaleMessage(lang, messages.default);
    loadedLanguages.push(lang);
    return setI18nLanguage(lang);
  });
}
